import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hotelPriceTransformer',
  standalone: true
})
export class HotelPriceTransformerPipe implements PipeTransform {

  transform(price: {amount: number;
    baseAmount: number;
    currency: "EUR"
    totalAmount: number}): unknown {
    return Math.ceil(price.totalAmount);
  }

}
